var map = {
	"./badge-fresh.svg": "98d7",
	"./badge-new.svg": "1879",
	"./badge-none.svg": "9f98",
	"./badge-premium.svg": "1caf",
	"./bg-about-line.svg": "ebfc",
	"./bg-body-left.svg": "5782",
	"./bg-body-right.svg": "fc93",
	"./bg-hero-icons.svg": "b43b",
	"./bg-hero.svg": "cb68",
	"./bg-services-landing-page-line.svg": "0a8d",
	"./icon-about-company.svg": "2070",
	"./icon-about-competition.svg": "1e3c",
	"./icon-about-date-1.svg": "001c",
	"./icon-about-date-2.svg": "8345",
	"./icon-about-date-3.svg": "ac29",
	"./icon-about-date-4.svg": "f7bd",
	"./icon-about-design.svg": "b50de",
	"./icon-about-hogyan.svg": "526d",
	"./icon-about-kik.svg": "65d4",
	"./icon-about-mennyiert.svg": "f8f3",
	"./icon-about-mit.svg": "7ba8",
	"./icon-about-target-group.svg": "c65b",
	"./icon-about-xs.svg": "0787",
	"./icon-about.svg": "74c5",
	"./icon-answer.svg": "0d5b",
	"./icon-back-to-top-hover.svg": "9851",
	"./icon-back-to-top.svg": "01f2",
	"./icon-blog-xs.svg": "5585",
	"./icon-blog.svg": "18e7",
	"./icon-bootstrap.svg": "2e78",
	"./icon-bootstrap5.svg": "ac3b",
	"./icon-contact-xs.svg": "6aff",
	"./icon-contact.svg": "51e0",
	"./icon-contents.svg": "f933",
	"./icon-cookie.svg": "0145",
	"./icon-css3.svg": "5a99",
	"./icon-custom-switch-dark.svg": "ea8d",
	"./icon-custom-switch-default.svg": "5b9f",
	"./icon-custom-switch-light.svg": "04c7",
	"./icon-firebase.svg": "3d6f",
	"./icon-gwd.svg": "ee61",
	"./icon-hamburger-off.svg": "0b85",
	"./icon-hamburger-on.svg": "7daf",
	"./icon-home-xs.svg": "48ef",
	"./icon-html5.svg": "1d8e",
	"./icon-javascript.svg": "c12d",
	"./icon-magento.svg": "c02c",
	"./icon-mouse.svg": "6ed5",
	"./icon-mysql.svg": "d4a9",
	"./icon-pack-l.svg": "5150",
	"./icon-pack-m.svg": "e89f",
	"./icon-pack-magento-1-active.svg": "c66c",
	"./icon-pack-magento-1.svg": "e9d1",
	"./icon-pack-magento-10-active.svg": "904b",
	"./icon-pack-magento-10.svg": "8489",
	"./icon-pack-magento-3-active.svg": "c0ed",
	"./icon-pack-magento-3.svg": "7a50",
	"./icon-pack-s.svg": "7826",
	"./icon-photoshop.svg": "89dc",
	"./icon-php.svg": "51f9",
	"./icon-products-magento-61.svg": "2da3",
	"./icon-products-magento-62.svg": "723f",
	"./icon-products-magento-63.svg": "a46f",
	"./icon-products-magento-64.svg": "e05b",
	"./icon-products-magento-65.svg": "e7f1",
	"./icon-products-magento-66.svg": "d0fd",
	"./icon-products-xs.svg": "27de",
	"./icon-products.svg": "1952",
	"./icon-question.svg": "e8b4",
	"./icon-scss.svg": "40b8",
	"./icon-services-xs.svg": "b4f5",
	"./icon-services.svg": "d4ff",
	"./icon-sketch.svg": "5356",
	"./icon-vscode.svg": "09bb",
	"./icon-vuejs.svg": "3527",
	"./light-bg-footer.svg": "cfbb",
	"./logo-footer.svg": "5b82",
	"./logo.svg": "02d9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6ddb";